var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRadioUnchecked = function SvgIconRadioUnchecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })));
};
export default SvgIconRadioUnchecked;